import ServiceHero from "@/components/service-hero";
import Image from "next/image";
import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper/modules";

import email1 from "@/public/images/email/email-1.png";
import email2 from "@/public/images/email/email-2.png";
import email3 from "@/public/images/email/email-3.jpg";
import email4 from "@/public/images/email/email-4.png";
import email5 from "@/public/images/email/email-5.jpg";
import email6 from "@/public/images/email/email-6.png";

const Hero = () => {
  return (
    <ServiceHero
      subtitle="We Work With Klaviyo, Mailchimp & Every Major ESP"
      title="Unlock Up to 25x ROI With Email & SMS Marketing"
      highlightedText="Up to 25x ROI"
      description="Turn first‑time shoppers into lifelong customers with data‑driven emails that run 24/7—so you earn more even while you sleep."
      buttonText="Book a Free Consultation"
      color="blue"
    >
      <Swiper
        effect="coverflow"
        grabCursor={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        centeredSlides={true}
        slidesPerView={3}
        slidesPerGroup={1}
        spaceBetween={0}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: true,
        }}
        modules={[EffectCoverflow, Pagination]}
        className="w-full"
      >
        {[email1, email2, email3, email4, email5, email6].map(
          (src, index) => (
            <SwiperSlide
              key={index}
              className="w-full overflow-hidden rounded-3xl border shadow-lg"
            >
              <Image
                src={src}
                alt={`Email Marketing Example ${index + 1}`}
                className="h-auto max-h-[300px] w-full object-contain object-top lg:max-h-[800px]"
              />
            </SwiperSlide>
          ),
        )}
      </Swiper>
    </ServiceHero>
  );
};

export default Hero;
